<script>
    import { onMount } from 'svelte'
    import { Mediator } from '../lib/mediator'
    import ModalOverlay from '../lib/ModalOverlay.svelte'
    import Settings from '../lib/Settings.svelte'
    import { ActiveRequests } from './activerequests';

    let settingModalVisible = false

</script>

<button class="transparent circle">
    <i class="page top active">settings</i>
    <menu class="no-wrap">
        <li on:click={() => settingModalVisible = !settingModalVisible}><i>settings</i><span>Settings</span></li>
    </menu>
</button>

<Settings bind:settingsOpen={settingModalVisible}/>

